module.exports = __webpack_public_path__ + "static/feature-window-03-f8b6218cdcbf3f1f715f5fb4a88bb31f.png";